export default __webpack_public_path__ + "static/media/PlusJakartaSans-Medium.7f57ef86.woff2";